"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var fa_1 = require("react-icons/fa");
require("../../styles/components/_navbar.scss");
var Link = /** @class */ (function (_super) {
    __extends(Link, _super);
    function Link() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeMenu: false,
        };
        _this.toggleMenu = function () {
            _this.setState({
                active: false,
                activeMenu: !_this.state.activeMenu,
            });
        };
        return _this;
    }
    Link.prototype.render = function () {
        return (react_1.default.createElement("nav", { className: 'navbar is-primary has-blur-shadow', role: 'navigation', "aria-label": 'main navigation' },
            react_1.default.createElement("div", { className: 'navbar-brand' },
                react_1.default.createElement("a", { className: 'navbar-item', href: 'https://ashish.me' },
                    react_1.default.createElement("img", { src: 'https://ashish.me/assets/img/logo.svg', alt: 'ashish.me', height: '128' })),
                react_1.default.createElement("a", { className: 'navbar-item is-hidden-desktop', href: 'https://github.com/ashishdotme' },
                    react_1.default.createElement(fa_1.FaGithub, null)),
                react_1.default.createElement("a", { className: 'navbar-item is-hidden-desktop', href: 'https://twitter.com/ashishdotme' },
                    react_1.default.createElement(fa_1.FaTwitter, null)),
                react_1.default.createElement("span", { role: 'button', className: "navbar-burger " + (this.state.activeMenu ? 'is-active' : ''), "aria-label": 'menu', "aria-expanded": 'false', "data-target": 'navbar.main', onClick: this.toggleMenu },
                    react_1.default.createElement("span", { "aria-hidden": 'true' }),
                    react_1.default.createElement("span", { "aria-hidden": 'true' }),
                    react_1.default.createElement("span", { "aria-hidden": 'true' }))),
            react_1.default.createElement("div", { id: 'navbar.main', className: "navbar-menu " + (this.state.activeMenu ? 'is-active' : '') },
                react_1.default.createElement("div", { className: 'navbar-start' },
                    react_1.default.createElement("a", { className: 'navbar-item', href: 'https://ashish.me/blog' }, "Blog"),
                    react_1.default.createElement("a", { className: 'navbar-item', href: 'https://notes.ashish.me' }, "Notes"),
                    react_1.default.createElement("a", { className: 'navbar-item', href: 'https://ashish.me/about' }, "About"),
                    react_1.default.createElement("a", { className: 'navbar-item', href: 'https://ashish.me/contact' }, "Contact"),
                    react_1.default.createElement("div", { className: 'navbar-item has-dropdown is-hoverable' },
                        react_1.default.createElement("span", { className: 'navbar-link' }, "More"),
                        react_1.default.createElement("div", { className: 'navbar-dropdown' },
                            react_1.default.createElement("a", { className: 'navbar-item', href: 'https://movies.ashish.me' }, "Movies"),
                            react_1.default.createElement("a", { className: 'navbar-item', href: 'https://shows.ashish.me' }, "TV Shows"),
                            react_1.default.createElement("a", { className: 'navbar-item', href: 'https://books.ashish.me' }, "Books"),
                            react_1.default.createElement("hr", { className: 'navbar-divider' }),
                            react_1.default.createElement("a", { className: 'navbar-item', href: 'https://courses.ashish.me' }, "Courses")))),
                react_1.default.createElement("div", { className: 'navbar-end' },
                    react_1.default.createElement("a", { className: 'navbar-item is-hidden-mobile', href: 'https://github.com/ashishdotme' },
                        react_1.default.createElement(fa_1.FaGithub, null)),
                    react_1.default.createElement("a", { className: 'navbar-item is-hidden-mobile', href: 'https://twitter.com/ashishdotme' },
                        react_1.default.createElement(fa_1.FaTwitter, null))))));
    };
    return Link;
}(react_1.PureComponent));
exports.default = Link;
//# sourceMappingURL=navbar.js.map